export const MONTHLY_TIMESHEET = 'MONTHLY_TIMESHEET';
export const CURRENT_DAILY_TS = 'CURRENT_DAILY_TS';
export const CURRENT_MONTHLY_TS = 'CURRENT_MONTHLY_TS';
export const SUBMIT_TIMESHEET = 'SUBMIT_TIMESHEET';
export const UPDATE_DAILY_TIMESHEET = 'UPDATE_DAILY_TIMESHEET';
export const APPROVE_TIMESHEET = 'APPROVE_TIMESHEET';
export const REJECT_TIMESHEET = 'REJECT_TIMESHEET';
